/* BELLVIA: popis produktu rozdělí podle nadpisů na řádky „text + fotka“
   (fotka se střídá vpravo/vlevo), aby krátký text nevedle velké fotky nevisel v prázdnu. */
(function () {
  function run() {
    var body = document.querySelector('.bv-desc__body');
    if (!body || body.dataset.bvRows) return;
    body.dataset.bvRows = '1';

    // 1) Rozdělit děti na skupiny: nová skupina začíná nadpisem h2–h4
    var groups = [];
    var current = [];
    Array.prototype.slice.call(body.children).forEach(function (el) {
      if (/^H[2-4]$/.test(el.tagName) && current.length) {
        groups.push(current);
        current = [];
      }
      current.push(el);
    });
    if (current.length) groups.push(current);

    // 2) Skupiny s fotkou převést na řádek text | fotka
    var rowIndex = 0;
    groups.forEach(function (els) {
      var media = els.filter(function (el) {
        return el.tagName === 'IMG' || (el.querySelector('img') && !el.textContent.trim());
      });
      if (!media.length) return;
      var row = document.createElement('div');
      row.className = 'bv-row' + (rowIndex % 2 ? ' bv-row--rev' : '');
      var text = document.createElement('div');
      text.className = 'bv-row__text';
      var pic = document.createElement('div');
      pic.className = 'bv-row__media';
      body.insertBefore(row, els[0]);
      els.forEach(function (el) {
        (media.indexOf(el) > -1 ? pic : text).appendChild(el);
      });
      row.appendChild(text);
      row.appendChild(pic);
      rowIndex++;
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();
})();

/* BELLVIA: názvy produktů psané celé VERZÁLKAMI (z Heliosu) zobrazí jako větu.
   Značka zůstane tak, jak je zapsaná u produktu (vendor), zkratky a slova s číslicí beze změny. */
(function () {
  var KEEP = ['SPF', 'UV', 'LED', 'USB', 'DC', 'DIY', 'XL', 'XXL', 'XS', 'PH', 'UK', 'EU', 'II', 'III'];
  var vendors = (window.BV_VENDORS || []).slice().sort(function (a, b) { return b.length - a.length; });
  var SEL = [
    '.product-card__title .reversed-link__text', '.product__title', '.cart-item__title',
    '.bv-b2b-bar__title', '.breadcrumbs span:last-child', '.sticky-atc-bar__title',
    '.predictive-search__item-heading', '.predictive-search a .text-pcard-title', '.product-card__info h3 a'
  ].join(',');

  function isShouty(t) {
    var letters = t.replace(/[^A-Za-zÀ-ž]/g, '');
    if (letters.length < 4) return false;
    var up = letters.replace(/[^A-ZÀ-ÞĀ-Ž]/g, '').length;
    var lower = (letters.match(/[a-zß-ÿā-ž]/g) || []).length;
    return lower / letters.length < 0.25 && up > 0;
  }

  function nice(t) {
    if (!isShouty(t)) return t;
    var out = t.split(/(\s+)/).map(function (w) {
      if (/^\s+$/.test(w)) return w;
      var bare = w.replace(/[^\wÀ-ž]/g, '');
      if (/\d/.test(w) && !/^\d+(ML|G|KG|L|KS|CM|MM)$/i.test(bare)) return w;
      if (KEEP.indexOf(bare.toUpperCase()) > -1) return w;
      return w.toLocaleLowerCase('cs');
    }).join('');
    vendors.forEach(function (v) {
      var i = out.toLocaleLowerCase('cs').indexOf(v.toLocaleLowerCase('cs'));
      if (i < 0) return;
      // značka velkým počátečním písmenem (IDC a jiné krátké zkratky zůstanou verzálkami)
      var brand = v === v.toUpperCase() ? v.split(' ').map(function (w) {
        return w.length <= 3 ? w : w.charAt(0) + w.slice(1).toLocaleLowerCase('cs');
      }).join(' ') : v;
      out = out.slice(0, i) + brand + out.slice(i + v.length);
    });
    return out.charAt(0).toLocaleUpperCase('cs') + out.slice(1);
  }

  function fix(root) {
    (root.querySelectorAll ? root : document).querySelectorAll(SEL).forEach(function (el) {
      if (el.dataset.bvNice || el.children.length) return;
      var t = el.textContent.trim();
      var n = nice(t);
      if (n !== t) el.textContent = n;
      el.dataset.bvNice = '1';
    });
  }

  function start() {
    fix(document);
    new MutationObserver(function (muts) {
      muts.forEach(function (m) { m.addedNodes.forEach(function (n) { if (n.nodeType === 1) fix(n); }); });
    }).observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();

/* BELLVIA: odhad doručení na detailu produktu (PPL doručí následující pracovní den).
   Objednávka v pracovní den do CUTOFF_HOUR se odesílá týž den. Časy podle Europe/Prague. */
(function () {
  var CUTOFF_HOUR = 12;
  var DAYS = ['neděli', 'pondělí', 'úterý', 'středu', 'čtvrtek', 'pátek', 'sobotu'];

  function pragueNow() {
    var p = new Intl.DateTimeFormat('en-CA', { timeZone: 'Europe/Prague', year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', hour12: false })
      .formatToParts(new Date()).reduce(function (o, x) { o[x.type] = x.value; return o; }, {});
    return { date: new Date(+p.year, +p.month - 1, +p.day), hour: +p.hour % 24, minute: +p.minute };
  }
  function easter(y) {
    var a = y % 19, b = Math.floor(y / 100), c = y % 100, d = Math.floor(b / 4), e = b % 4, f = Math.floor((b + 8) / 25),
      g = Math.floor((b - f + 1) / 3), h = (19 * a + b - d - g + 15) % 30, i = Math.floor(c / 4), k = c % 4,
      l = (32 + 2 * e + 2 * i - h - k) % 7, m = Math.floor((a + 11 * h + 22 * l) / 451),
      month = Math.floor((h + l - 7 * m + 114) / 31), day = ((h + l - 7 * m + 114) % 31) + 1;
    return new Date(y, month - 1, day);
  }
  function key(d) { return d.getFullYear() + '-' + (d.getMonth() + 1) + '-' + d.getDate(); }
  var holidayCache = {};
  function isHoliday(d) {
    var y = d.getFullYear();
    if (!holidayCache[y]) {
      var set = {};
      ['1-1', '5-1', '5-8', '7-5', '7-6', '9-28', '10-28', '11-17', '12-24', '12-25', '12-26'].forEach(function (md) {
        var p = md.split('-'); set[y + '-' + p[0] + '-' + p[1]] = 1;
      });
      var e = easter(y);
      set[key(new Date(y, e.getMonth(), e.getDate() - 2))] = 1;   // Velký pátek
      set[key(new Date(y, e.getMonth(), e.getDate() + 1))] = 1;   // Velikonoční pondělí
      holidayCache[y] = set;
    }
    return !!holidayCache[y][key(d)];
  }
  function isWorkday(d) { var w = d.getDay(); return w !== 0 && w !== 6 && !isHoliday(d); }
  function nextWorkday(d) { var x = new Date(d); do { x.setDate(x.getDate() + 1); } while (!isWorkday(x)); return x; }

  function estimate() {
    var now = pragueNow();
    var beforeCutoff = isWorkday(now.date) && now.hour < CUTOFF_HOUR;
    var ship = beforeCutoff ? now.date : nextWorkday(now.date);
    var deliver = nextWorkday(ship);
    var tomorrow = new Date(now.date); tomorrow.setDate(tomorrow.getDate() + 1);
    var day = DAYS[deliver.getDay()];
    var prep = (day === 'středu' || day === 'čtvrtek') ? 've' : 'v';
    var when = prep + ' ' + day + ' ' + deliver.getDate() + '. ' + (deliver.getMonth() + 1) + '.';
    var isTomorrow = key(deliver) === key(tomorrow);
    var text = 'Doručíme ' + (isTomorrow ? 'zítra, ' : '') + when;
    var hint = beforeCutoff ? 'při objednávce do ' + CUTOFF_HOUR + ':00' : '';
    return { text: text, hint: hint };
  }

  function render() {
    var anchor = document.querySelector('.product__info-container .product__block--inventory') ||
                 document.querySelector('.product__info-container .product__block--price');
    if (!anchor || document.querySelector('.bv-delivery')) return;
    var stock = document.querySelector('.product__info-container .product__block--inventory');
    if (stock && /vyprodáno|není skladem/i.test(stock.textContent)) return;
    var e = estimate();
    var el = document.createElement('div');
    el.className = 'bv-delivery product__block';
    el.innerHTML = '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M3 7h11v9H3zM14 10h4l3 3v3h-7"/><circle cx="7" cy="17.5" r="1.5"/><circle cx="17" cy="17.5" r="1.5"/></svg>' +
      '<span><strong>' + e.text + '</strong>' + (e.hint ? ' <span class="bv-delivery__hint">' + e.hint + '</span>' : '') + '</span>';
    anchor.insertAdjacentElement('afterend', el);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', render);
  else render();
})();

/* BELLVIA: mega menu Katalog — najetí na hlavní větev přepne panel vpravo
   (s malou prodlevou, aby šikmý pohyb myši k panelu nepřepínal sousední větve). */
(function () {
  var timer = null;
  function activate(tab) {
    var root = tab.closest('.bv-mega');
    if (!root || tab.classList.contains('is-active')) return;
    var id = tab.getAttribute('data-bv-tab');
    root.querySelectorAll('[data-bv-tab]').forEach(function (t) { t.classList.toggle('is-active', t === tab); });
    root.querySelectorAll('[data-bv-panel]').forEach(function (p) { p.classList.toggle('is-active', p.getAttribute('data-bv-panel') === id); });
  }
  document.addEventListener('mouseover', function (e) {
    var tab = e.target.closest && e.target.closest('[data-bv-tab]');
    clearTimeout(timer);
    if (tab) timer = setTimeout(function () { activate(tab); }, 90);
  });
  document.addEventListener('focusin', function (e) {
    var tab = e.target.closest && e.target.closest('[data-bv-tab]');
    if (tab) activate(tab);
  });
})();
